import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import UploadView from './components/UploadView';
import LoadingView from './components/LoadingView';
import RoastView from './components/RoastView';
import PaymentWall from './components/PaymentWall';
import SeriousView from './components/SeriousView';
import SafeIcon from './common/SafeIcon';

// States: 'upload' | 'analyzing_roast' | 'roasted' | 'payment_wall' | 'processing_payment' | 'serious'

export default function App() {
  const [appState, setAppState] = useState('upload');
  const [fileName, setFileName] = useState('');

  const handleUpload = (file) => {
    setFileName(file.name);
    setAppState('analyzing_roast');
  };

  const handleRoastComplete = () => {
    setAppState('roasted');
  };

  const handleUpgradeClick = () => {
    setAppState('payment_wall');
  };

  // This is triggered immediately after the user clicks the Cash App link
  const handlePaymentInitiated = () => {
    setAppState('processing_payment');
  };

  const handleAnalysisComplete = () => {
    setAppState('serious');
  };

  const handleReset = () => {
    setAppState('upload');
    setFileName('');
  };

  return (
    <div className="min-h-screen bg-[#020617] text-slate-50 overflow-x-hidden flex flex-col relative">
      {/* Global Background Effects */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-rose-900/20 blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-emerald-900/10 blur-[120px]" />
      </div>

      {/* Main Content Area */}
      <main className="flex-grow flex items-center justify-center p-6 relative z-10 w-full max-w-6xl mx-auto">
        <AnimatePresence mode="wait">
          {appState === 'upload' && (
            <UploadView key="upload" onUpload={handleUpload} />
          )}

          {appState === 'analyzing_roast' && (
            <LoadingView key="loading_roast" type="roast" onComplete={handleRoastComplete} />
          )}

          {appState === 'roasted' && (
            <RoastView key="roasted" onUpgrade={handleUpgradeClick} />
          )}

          {appState === 'payment_wall' && (
            <PaymentWall 
              key="payment" 
              onPaymentComplete={handlePaymentInitiated} 
              onBack={() => setAppState('roasted')}
            />
          )}

          {appState === 'processing_payment' && (
            <LoadingView key="loading_serious" type="serious" onComplete={handleAnalysisComplete} />
          )}

          {appState === 'serious' && (
            <SeriousView key="serious" onReset={handleReset} />
          )}
        </AnimatePresence>
      </main>

      {/* Footer */}
      <footer className="py-6 text-center text-slate-500 text-sm relative z-10">
        <p className="flex items-center justify-center gap-2">
           AI Resume Roast Prototype <span className="opacity-50">|</span> Built for speed to value.
        </p>
      </footer>
    </div>
  );
}